<template>
    <div>
      <div v-show="conteudo.pagamento_atendimento && tem_endereco_antigo" >
        <div class="row">
          <div class="col col-12 col-md-4 d-flex align-items-start">
            <div class="custom-control custom-switch my-3">
              <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitchAll"
                  v-model="outro_responsavel"
                  :disabled="!podeEditar"
                  @click="ajustar_selecao"
              />
              <label
                  class="custom-control-label"
                  for="customSwitchAll"
              >Informar outro responsável financeiro</label>
            </div>
          </div>
          <template v-if="outro_responsavel">
            <div class="col col-12 col-md-3">
              <az-input
                  sizing="sm"
                  label="CPF/CNPJ"
                  type="cpf-cnpj"
                  placeholder="CPF / CNPJ..."
                  v-model="conteudo.pagamento_atendimento.st_cpf_cnpj"
                  required
                  :validate="validate"
                  :edicao="podeEditar"
                  @input="pesquisarCpf" />
            </div>
            <div class="col col-12 col-md-5">
              <az-input
                  sizing="sm"
                  label="Nome/Empresa"
                  placeholder="Nome / Empresa..."
                  v-model="conteudo.pagamento_atendimento.st_responsavel_financeiro"
                  required
                  :edicao="podeEditar"
                  :validate="validate" />
            </div>
          </template>
        </div>

        <div class="row" v-if="outro_responsavel">
          <div class="col col-12 col-md-7">
            <az-input
                sizing="sm"
                label="Endereço"
                placeholder="Endereço..."
                v-model="conteudo.pagamento_atendimento.st_endereco"
                required
                :validate="validate"
                :edicao="podeEditar"
            />
          </div>
          <div class="col col-12 col-md-5">
            <az-input
                sizing="sm"
                label="e-mail"
                type="email"
                placeholder="e-mail"
                v-model="conteudo.pagamento_atendimento.st_email"
                :validate="validate"
                :edicao="podeEditar"
            />
          </div>
          <div class="col col-12 col-md-5">
            <az-input
                v-if="conteudo.pagamento_atendimento.st_cpf_cnpj && conteudo.pagamento_atendimento.st_cpf_cnpj.length == 14"
                sizing="sm"
                label="Reter ISS"
                type="checkbox-group"
                v-model="conteudo.pagamento_atendimento.ch_iss_retido"
                :validate="validate"
                :edicao="podeEditar"
            />
          </div>
        </div>
      </div>

        <div v-show="conteudo.pagamento_atendimento && !tem_endereco_antigo"> <!-- && !atendimento.pendente"> -->
          <div class="row">
            <div class="col col-12 col-md-12 d-flex align-items-start">
              <div class="custom-control custom-switch my-3">
                <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customSwitchAll"
                    v-model="outro_responsavel"
                    @click="ajustar_selecao"
                    :disabled="!podeEditar" />
                <label
                    class="custom-control-label"
                    for="customSwitchAll"
                >Informar outro responsável financeiro</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col col-12 col-md-6">
              <div class="row">
                <div class="col col-12 col-md-12" v-if="outro_responsavel">
                  <az-input
                      sizing="sm"
                      label="CPF/CNPJ"
                      type="cpf-cnpj"
                      placeholder="CPF / CNPJ..."
                      v-model="conteudo.pagamento_atendimento.st_cpf_cnpj"
                      required
                      :validate="validate"
                      :edicao="podeEditar"
                      @input="pesquisarCpf"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col col-12 col-md-12" v-if="outro_responsavel">
                  <az-input
                      sizing="sm"
                      label="Nome/Empresa"
                      placeholder="Nome / Empresa..."
                      v-model="conteudo.pagamento_atendimento.st_responsavel_financeiro"
                      required
                      :edicao="podeEditar"
                      :validate="validate"
                  />
                </div>
              </div>

              <div class="row" v-if="outro_responsavel">
                <div class="col col-12 col-md-12">
                  <az-input
                      sizing="sm"
                      label="e-mail"
                      type="email"
                      placeholder="e-mail"
                      v-model="conteudo.pagamento_atendimento.st_email"
                      :edicao="podeEditar"
                      :validate="validate"
                  />
                </div>
                <div class="col col-12 col-md-12">
                  <az-input
                      v-if="conteudo.pagamento_atendimento.st_cpf_cnpj && conteudo.pagamento_atendimento.st_cpf_cnpj.length == 14"
                      sizing="sm"
                      class="mt-4"
                      label="Reter ISS"
                      type="checkbox-group"
                      v-model="conteudo.pagamento_atendimento.ch_iss_retido"
                      :validate="validate"
                      :edicao="podeEditar"
                  />
                </div>
              </div>
            </div>

            <div class="col col-12 col-md-6">
              <div class="row" v-if="outro_responsavel">
                <div class="col col-12 col-md-12">
                  <cadastro-endereco sizing="sm" :edicao="podeEditar" v-model="conteudo.pagamento_atendimento.endereco"/>
                </div>
              </div>
            </div>
          </div>

        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import CadastroEndereco from "@/components/shared/CadastroEndereco.vue";

export default {
    data() { 
        return { 
            outro_responsavel: false, 
            montando: true, 
            conteudo: {},
            tem_endereco_antigo: false,
        };
    }, 

    components: {
      CadastroEndereco,
        AzInput,
    },

    props: ['validate', 'value', 'notas'], 

    watch: { 
        conteudo: {
            handler: function (newValue) {
                this.$emit('input', newValue);
            },
            deep: true, 
        },
    },

    computed: {
        podeEditar: function() {
            if(!this.notas) return true;
            if(!Array.isArray(this.notas)) return true;

            let resultado = true;
            this.notas.forEach(item => {
                let nfStatus = _.get(item, 'nota_fiscal_servico.ch_status');
                if(nfStatus != '5' && resultado) resultado = false;
            });

            return resultado;
        }
    },

    methods: { 
        ajustar_selecao () {
            if ( !this.montando ) {
                this.conteudo.pagamento_atendimento.st_responsavel_financeiro = "";
                this.conteudo.pagamento_atendimento.st_cpf_cnpj = "";
                this.conteudo.pagamento_atendimento.st_endereco = "";
                this.conteudo.pagamento_atendimento.st_email = "";
                this.conteudo.pagamento_atendimento.id_endereco = null;
                this.conteudo.pagamento_atendimento.endereco = {};
            }
        },

        pesquisarCpf(cpf) {
            if ( this.montando )
                return; 

            if ( cpf && cpf.length == 11 ) {

                if(_.get(this.conteudo, 'pagamento_atendimento.endereco.id_endereco')) {
                  return;
                }

                this.$util.loadItem(this, {
                    service:'pacientes',
                    func: 'index',
                    parms: {
                        search: cpf,
                    }
                })
                .then(res => {
                    if ( res && res.length >= 1 ) {
                        this.value.pagamento_atendimento.st_responsavel_financeiro = res[0].st_nome;
                        this.value.pagamento_atendimento.st_email = res[0].cadastro ? res[0].cadastro.st_email : '';

                        if ( res[0].cadastro && res[0].cadastro.endereco ) {

                        const endereco = res[0].cadastro.endereco.st_logradouro +
                            ( res[0].cadastro.endereco.st_complemento ? ', ' + res[0].cadastro.endereco.st_complemento : '' ) +
                            ( res[0].cadastro.endereco.st_numero ? ', No.' + res[0].cadastro.endereco.st_numero : '' ) +
                            ( res[0].cadastro.endereco.st_numero ? ', No.' + res[0].cadastro.endereco.st_numero : '' ) +
                            ( res[0].cadastro.endereco.st_bairro ? ', ' + res[0].cadastro.endereco.st_bairro : '' ) +
                            ( res[0].cadastro.endereco.in_cep ? ', CEP ' + res[0].cadastro.endereco.in_cep : '' ) +
                            ( res[0].cadastro.endereco.cidade ? ', ' + res[0].cadastro.endereco.cidade.st_cidade : '' );

                        this.conteudo.pagamento_atendimento.st_endereco = endereco;

                        if(this.conteudo.pagamento_atendimento.endereco && !this.tem_endereco_antigo) {
                          this.conteudo.pagamento_atendimento.endereco = res[0].cadastro.endereco;
                        }

                        }
                    }
                });
            }

            if(!cpf || (cpf && cpf.length == 0)) {
                this.conteudo.pagamento_atendimento.st_responsavel_financeiro = '';
                this.conteudo.pagamento_atendimento.st_email = '';
                this.conteudo.pagamento_atendimento.st_endereco = '';
                this.conteudo.pagamento_atendimento.endereco = {};
            }
        },
    }, 

    mounted() {

        this.conteudo = _.cloneDeep(this.value);
        if(this.conteudo.pagamento_atendimento && !this.conteudo.pagamento_atendimento.endereco) {
            this.conteudo.pagamento_atendimento.endereco = {};
        }

        this.outro_responsavel = this.value.pagamento_atendimento.st_responsavel_financeiro
            ? true 
            : false;

        const enderecoAntigo = _.get(this.conteudo, 'pagamento_atendimento.st_endereco');
        const enderecoNovo = _.get(this.conteudo, 'pagamento_atendimento.endereco.id_endereco');
        this.tem_endereco_antigo = enderecoAntigo && !enderecoNovo ? true: false;

        this.montando = false;
    }
}
</script>
